import moduleGridCustomButtons from "../modules/gridCustomButtons";
import moduleHistory from "../modules/history";
import moduleProgress from "../modules/progress";
import moduleResources from "../modules/resources";
import moduleCustomColumns from "../modules/customColumns";
import moduleEstimation from "../modules/estimation";
import moduleGridActionButtons from "../modules/gridActionButtons";
import moduleWorkDays from "../modules/workDays";
import moduleLink from "../modules/link";
import moduleTextAlign from "../modules/textAlign";
import moduleCustomGrids from "../modules/customGrids";
import moduleDnD from "../modules/dragndrop";

export default {
  beforeInit: [
    moduleCustomGrids,
    moduleGridCustomButtons,
    moduleHistory
  ],
  init: [
    moduleProgress,
    moduleResources,
    moduleCustomColumns,
    moduleEstimation,
    moduleGridCustomButtons,
    moduleGridActionButtons,
    moduleWorkDays,
    moduleLink,
    moduleTextAlign,
    moduleHistory,
    // moduleBaseline,
  ],
  dependencyInit: [
    {
      module: moduleCustomGrids,
      callBack: () => {}
    },
    {
      module: moduleGridActionButtons,
      callBack: moduleResources.handlers.deleteResourceFromTask
    },
    {
      module: moduleDnD,
      callBack: moduleResources.handlers.deleteResourceFromTask
    },
    {
      module: moduleResources,
      callBack: () => {}
    }
  ],
};